// label is now "name · number"; value (channelId) unchanged — item 12 relies on it.
export function enterpriseChannels(org) {
  return (org?.channels || [])
    .filter((channel) => channel.channelType === 'enterprise')
    .map((channel) => ({
      ...channel,
      label: `${channel.channelName} · ${channel.whatsappNo}`,
      value: channel.channelId,
      type: 'enterprise',
    }));
}

// org.config.mmLiteNumbers (ops-set, PUT /integrations/org/{id}) and a channel's own whatsappNo
// may each carry a leading '+' independently of the other — compare digits only so either storage
// form on either side still matches.
export function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '');
}

// True when `channel`'s WhatsApp number is one of the account's MM Lite numbers. MM Lite is an
// Enterprise-account-level flag with no read API this widget can call directly — see
// Templates/index.js's own comment for where mmLiteNumbers comes from.
export function isMmLiteChannel(channel, mmLiteNumbers) {
  const whatsappDigits = digitsOnly(channel?.whatsappNo);
  if (!whatsappDigits || !Array.isArray(mmLiteNumbers)) return false;
  return mmLiteNumbers.some((number) => digitsOnly(number) === whatsappDigits);
}
